module.exports = __webpack_public_path__ + "media/images/mr3-9fd991398cd5d5192e0c3107924407cc.jpg";